import { getFormToken } from 'components/molecules/SpamGuard/formToken';
import { FORM_TOKEN_FIELD } from 'components/molecules/SpamGuard/spamGuard.constants';

export interface GenericSubmitHandlerProps {
  data: any;
}
export interface FetchSendFormResponse {
  data: any;
}

export const newsletterSubmitHandler = async ({
  data,
}: GenericSubmitHandlerProps): Promise<FetchSendFormResponse> => {
  try {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...data, [FORM_TOKEN_FIELD]: await getFormToken() }),
    };
    const response = await fetch('/api/mailchimp', options);
    return {
      data: response,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};
